import Grid from '@mui/material/Grid';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { useGiftOrdersHeaders } from 'modules/support-gift-orders/hooks/gift-orders-header/useGiftOrdersHeader';

const GiftOrdersHeaderDatePickers = () => {
  // Hook propio de la funcionalidad del encabezado (filtros)
  const { datePickerOnChange, fromDateValue, toDateValue } = useGiftOrdersHeaders();

  return (
    <>
      <Grid item size={{ xs: 6, lg: 2 }} className={'filter-container'}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es'}>
          <DatePicker
            value={fromDateValue}
            onChange={(newValue) => datePickerOnChange(newValue, 'from')}
            maxDate={dayjs()}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item size={{ xs: 6, lg: 2 }} className={'filter-container'}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es'}>
          <DatePicker
            value={toDateValue}
            onChange={(newValue) => datePickerOnChange(newValue, 'to')}
            maxDate={dayjs()}
          />
        </LocalizationProvider>
      </Grid>
    </>
  );
};

export default GiftOrdersHeaderDatePickers;
